import { render, staticRenderFns } from "./KeyboardCat.vue?vue&type=template&id=ed087364&scoped=true"
import script from "./KeyboardCat.vue?vue&type=script&lang=js"
export * from "./KeyboardCat.vue?vue&type=script&lang=js"
import style0 from "./KeyboardCat.vue?vue&type=style&index=0&id=ed087364&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed087364",
  null
  
)

export default component.exports